import React from "react";

import { IconProps } from "../../types/common";

const DownloadIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#63696F",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M15 9.5h1.59a1 1 0 01.7 1.71L12.7 15.8a1 1 0 01-1.41 0L6.7 11.21a1 1 0 01.71-1.71H9v-5a1 1 0 011-1h4a1 1 0 011 1v5zm-9 11a1 1 0 01-1-1 1 1 0 011-1h12a1 1 0 011 1 1 1 0 01-1 1H6z"
    />
  </svg>
);

export default DownloadIcon;
